// extracted by mini-css-extract-plugin
export default {"mapImage":"Location_mapImage__nmXi4"};